import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";
import { IMG } from "@/lib/images";
import { fadeUp, stagger, viewportOnce } from "@/lib/motion";

export const Arrival = () => {
  const { t } = useLang();
  return (
    <section
      id="journey"
      data-testid="arrival-section"
      className="relative py-28 md:py-40 bg-ivory text-forest"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center"
        >
          <motion.div variants={fadeUp} className="lg:col-span-6">
            <div className="aspect-[5/4] w-full overflow-hidden">
              <img src={IMG.forest} alt="The wooden entry gate to Yuzenya opening onto a boardwalk through pine forest toward the retreat cabins." className="w-full h-full object-cover hover-img" />
            </div>
          </motion.div>
          <motion.div variants={fadeUp} className="lg:col-span-5 lg:col-start-8">
            <p className="overline text-bronze mb-6">{t.arrival.eyebrow}</p>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight">
              {t.arrival.title}
            </h2>
            <div className="mt-8 text-base md:text-lg leading-relaxed text-forest/80 space-y-6 max-w-md">
              <p>{t.arrival.body_1}</p>
              <p>{t.arrival.body_2}</p>
              <p className="font-serif italic text-xl md:text-2xl text-forest/90 leading-snug">
                {t.arrival.body_3}
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
